export function calculateAge(dateStr: string | undefined): number | null {
  if (!dateStr) {
    console.error('Error: Date string is undefined or empty.');
    return null;
  }

  const parts = dateStr.split('-').map(Number);
  if (parts.length !== 3 || parts.some(isNaN)) {
    console.error('Error: Invalid date format. Expected format: YYYY-MM-DD.');
    return null;
  }

  const [year, month, day] = dateStr.split('-').map(Number);
  const birthDate = new Date(year, month - 1, day);

  if (isNaN(birthDate.getTime())) {
    console.error('Error: Invalid birth date.');
    return null;
  }

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();

  if (
    today.getMonth() < birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() &&
      today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
}
